import React, { useRef, useState, useEffect } from "react";
import Popup from "reactjs-popup";
import AvatarEditor from "react-avatar-editor";
import "reactjs-popup/dist/index.css";
import Styles from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import {changeAvatar, setSettingsAvatarModalStatus} from "../../store/cabinet/action";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";

const CabinetSettingsAvatarModal = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const settingsAvatarModalStatus = useSelector((store) => store.cabinet.settingsAvatarModalStatus);

    const editorRef = useRef(null);
    // Создаём ref для input file
    const fileInputRef = useRef(null);
    const [scale, setScale] = useState(1);
    const [image, setImage] = useState(null);

    // Состояние для динамических размеров редактора
    const [editorSize, setEditorSize] = useState({
        width: window.innerWidth > 767 ? 250 : 150,
        height: window.innerWidth > 767 ? 250 : 150,
    });

    // Обновление размеров редактора при изменении размера окна
    useEffect(() => {
        const updateEditorSize = () => {
            if (window.innerWidth > 767) {
                setEditorSize({ width: 250, height: 250 });
            } else {
                setEditorSize({ width: 150, height: 150 });
            }
        };

        window.addEventListener("resize", updateEditorSize);
        // Вызовем сразу, чтобы установить корректные размеры при монтировании
        updateEditorSize();

        return () => {
            window.removeEventListener("resize", updateEditorSize);
        };
    }, []);

    const closeModal = () => {
        dispatch(setSettingsAvatarModalStatus(false));
        setScale(1);
        setImage(null);
    };

    const handleScaleChange = (e) => {
        const scaleValue = parseFloat(e.target.value);
        setScale(scaleValue);
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            // Создаём URL для выбранного файла
            const imageUrl = URL.createObjectURL(file);
            setImage(imageUrl);
        }
    };

    const handleSave = () => {
        if (editorRef.current) {
            const canvas = editorRef.current.getImageScaledToCanvas();
            // Преобразуем canvas в Blob
            canvas.toBlob((blob) => {
                if (blob) {
                    const file = new File([blob], 'avatar.png', { type: 'image/png' });
                    const formData = new FormData();
                    formData.append('avatar', file);
                    dispatch(changeAvatar(formData));
                    toast(t('Ваш аватар успешно изменён!'));
                    closeModal();
                }
            }, 'image/png'); // можно указать "image/jpeg", если требуется
        }
    };

    // Функция для симуляции клика по скрытому input
    const triggerFileSelect = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <Popup
            open={settingsAvatarModalStatus}
            modal
            nested
            closeOnDocumentClick
            onClose={closeModal}
        >
            <div className={`${Styles.modalContainer}`}>
                <div className={`${Styles.modalCloseBtn}`} onClick={closeModal}>
                    <div />
                    <div />
                </div>
                <div className={`${Styles.modalContentWrap}`}>
                    <div className={`${Styles.modalTitle}`}>{t('Сменить аватар')}</div>
                    <div className={`${Styles.modalContentBox}`}>
                        {/* Скрытый input для загрузки файла */}
                        <input
                            type="file"
                            accept="image/*"
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            style={{ display: "none" }}
                        />
                        {image ? (
                            <div className={`${Styles.avatarWrap}`}>
                                <AvatarEditor
                                    ref={editorRef}
                                    image={image} // Используем загруженное изображение
                                    width={editorSize.width} // Динамический размер по ширине
                                    height={editorSize.height} // Динамический размер по высоте
                                    border={50}
                                    color={[255, 215, 0, 0.25]}
                                    // Если хотите оставить круглую форму, можно задать borderRadius как половину от ширины
                                    borderRadius={editorSize.width / 2}
                                    scale={scale}
                                    rotate={0}
                                />
                            </div>
                        ) : (
                            <div className={`${Styles.avatarEmpty}`}>
                                {t('Загрузите изображение для редактирования')}
                            </div>
                        )}
                        <div className={`${Styles.rangeWrap}`}>
                            {image ? (
                                <input
                                    type="range"
                                    min="1"
                                    max="3"
                                    step="0.01"
                                    value={scale}
                                    onChange={handleScaleChange}
                                />
                            ) : null}
                        </div>
                        <div
                            className={`${Styles.btnsWrap} ${
                                !image ? Styles.btnsWrapOne : ""
                            }`}
                        >
                            <div
                                className={`${Styles.ftfBorderBtn}`}
                                onClick={triggerFileSelect}
                            >
                                {t('Выбрать файл')}
                            </div>
                            {image ? (
                                <div
                                    className={`${Styles.ftfBorderBtn}`}
                                    onClick={handleSave}
                                >
                                    {t('Сохранить')}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </Popup>
    );
};

export default CabinetSettingsAvatarModal;
